<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <div class="container">
            <!-- <a class="navbar-brand" href="/">WAPAC QUIZZING</a> -->
            <router-link class="navbar-brand" to="/">JUMPSTER/WAPAC</router-link>
            <button class="navbar-toggler" type="button" @click="clicked" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
                <div class="collapse navbar-collapse" :class="{show: collapse}" id="navbarSupportedContent">
                    <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li class="nav-item">
                            <router-link class="nav-link" @click.native="clicked" to="/">SCHEDULE</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" @click.native="clicked" to="/resources">RESOURCES</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/results/">RESULTS</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" @click.native="clicked" to="/register">REGISTER</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" @click.native="clicked" to="/officials">OFFICIALS</router-link>
                        </li>
                        <!-- <li class="nav-item">
                            <router-link class="nav-link" @click.native="clicked" to="/login">LOGIN</router-link>
                        </li> -->
                    </ul>
                </div>
        </div>
    </nav>
</template>

<script>
    export default { 
        name: 'Navigation',
        props: {
        },
        data: function() {
            return {
                collapse: false 
            }
        },
        methods: {
            clicked: function() {
                this.collapse = !this.collapse;
            }
        }
    }
</script>

<style scoped>
.nav-item {
    font-size: 120%;
    letter-spacing: 3px;
    margin: 0 .75em;
}
.bg-light {
    background-color: #f4f4f4 !important;
}
.navbar-brand {
    font-size: 130%;
}

</style>